import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  objectTypeId: ObjectTypeIdType.isRequired
};
const EmptyObjectSearchState = ({
  objectTypeId
}) => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 200
    },
    title: /*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.generic-enrollment-table.errors.title_cob",
        objectTypeId: objectTypeId
      })
    }),
    children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.generic-enrollment-table.errors.body_cob",
      objectTypeId: objectTypeId
    })
  });
};
EmptyObjectSearchState.propTypes = propTypes;
export default EmptyObjectSearchState;